import React from 'react'
import Image from 'components/Common/Image'
import config from 'constants/config'

function ExperiencesPageWhiteLabelBannerAd() {
  if (!config.EXPERIENCES_BANNER_AD_ID) { return null }

  return <Image id={config.EXPERIENCES_BANNER_AD_ID} alt={config.EXPERIENCES_BANNER_AD_ALT_TEXT || ''} format="png" style={{ maxWidth: '100%' }} />
}

export default ExperiencesPageWhiteLabelBannerAd
